import React from "react"
import PropTypes from "prop-types"

import {NestedRoute} from "@irati/utils/history/routing"
import {HasPermissionTo} from "@irati/utils/permissions"

import sitemap from "../sitemap"
import AnalysisController from "../pages/AnalysisController"


const AnalysisRoutes = ({match}) => {
  return (
    <HasPermissionTo permissions="insights.survey">
      <NestedRoute match={match.path} {...sitemap.analysis} useGrid={false} component={AnalysisController} />
    </HasPermissionTo>
  )
}


AnalysisRoutes.propTypes = {
  match: PropTypes.object.isRequired
}
AnalysisRoutes.defaultProps = {}

export default AnalysisRoutes
